<template lang="pug">
.purchase-list.pagination
    .error(v-if="error")
        template(v-if="error.code")
            Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
        template(v-else)
            Error(:message="$t('Something went wrong!')" :code="501")
    .purchases-table(v-else)
        //- :row-link-config="purchasesPaginated.link"
        paginated-items(
            scope="ex"
            type="shop_purchase"
            :loading="loading"
            :items="purchasesPaginated.items"
            :filters="filters"
            :show-filters="showFilters"
            :variables="purchasesPaginated.variables"
            :all-columns="purchasesPaginated.allColumns"
            :active-columns="purchasesPaginated.activeColumns"
            :page-info="purchasesPaginated.pageInfo"
            :sort="sort"
            @pagination-size-change="handleSizeChange"
            @pagination-current-change="handleCurrentChange"
            @show-table-columns="handleColsShow"
            @change-filter="handleFilterInputChange"
            @click="handleClick"
            @change-sort="handleSortInputChange"
        )
            template(slot="top")
                el-row.table-top(v-loading="loading" type="flex" justify="space-between")
                    .row
                        .left
                            el-button(type="primary" size="mini" icon="el-icon-fa-plus fas" @click="addPurchase")
                                | {{ $t('New Purchase') }}
                        .middle.hide-on-empty
                            //- span.info 35197 Bestellungen gefunden (2 ausgewählt)
                            span.info
                                | {{ $t('Found {total} purchases', { total: purchasesPaginated.pageInfo.total }) }}
                            template(v-if="bulk.action || purchasesPaginated.pageInfo.selection.total > 0")
                                hr.vertical
                                span.info {{ $t('{total} selected', { total: purchasesPaginated.pageInfo.selection.total }) }}
                            //- el-button(
                            //-     round
                            //-     :plain="showRelatedArticles === false" size="mini"
                            //-     :icon="showRelatedArticles === false ? 'el-icon-fa-eye far' : 'el-icon-fa-eye-slash far'"
                            //-     @click="handleChildrenVisibilityChange"
                            //- ) {{ $t(showRelatedArticles === false ? 'Show related purchases' : 'Hide related purchases') }}
                        .right.hide-on-empty
                            //- span {{ $t('Selected purchases') }}:
                            .bulk-actions
                                el-select(
                                    v-model="bulk.action"
                                    size="mini"
                                    :placeholder="$t('Select bulk action...')"
                                    clearable
                                )
                                    el-option(
                                        v-for="item in bulk.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    )
                                transition(name="slide-decent-left")
                                    el-button(
                                        v-if="purchasesPaginated.pageInfo.selection.total > 0 || bulk.action"
                                        type="primary"
                                        size="mini"
                                        :disabled="!bulk.action || purchasesPaginated.pageInfo.selection.total <= 0"
                                        icon="el-icon-fa-check fas"
                                        @click.stop.prevent="event => handleBulkAction()"
                                    )
                                        | {{ $t('Go') }}
                            hr.vertical
                            el-button(
                                plain
                                size="mini"
                                type="primary"
                                icon="el-icon-fa-filter fas"
                                @click="toggleFilterVisiblity"
                                :disabled="disable.showFilters || hasFilters"
                            )
                                span(v-if="showFilters") {{ $t('Hide filters') }}
                                span(v-else) {{ $t('Show filters') }}
                    .row(v-if="enabledExtensions.includes('shop:point-of-sale') || hasMarketplacePurchases")
                        .left
                        .middle
                        .right
                            el-button(
                                v-if="enabledExtensions.includes('shop:point-of-sale') || hasMarketplacePurchases"
                                type="primary"
                                :type="includeWebShopPurchases == true ? 'primary' : 'info'"
                                size="mini"
                                :icon="includeWebShopPurchases == true ? 'el-icon-fa-eye far' : 'el-icon-fa-eye-slash far'"
                                @click="toggleWebShopPurchasesFilter"
                            )
                                | {{ $t('Web Shop Purchases') }}
                            el-button(
                                v-if="enabledExtensions.includes('shop:point-of-sale')"
                                :type="includePointOfSalePurchases == true ? 'primary' : 'info'"
                                size="mini"
                                :icon="includePointOfSalePurchases == true ? 'el-icon-fa-eye far' : 'el-icon-fa-eye-slash far'"
                                @click="togglePointOfSalePurchasesFilter"
                            )
                                | {{ $t('Point Of Sale Purchases') }}
                            el-button(
                                v-if="hasMarketplacePurchases"
                                :type="includeMarketplacePurchases == true ? 'primary' : 'info'"
                                size="mini"
                                :icon="includeMarketplacePurchases == true ? 'el-icon-fa-eye far' : 'el-icon-fa-eye-slash far'"
                                @click="toggleMarketplacePurchasesFilter"
                            )
                                | {{ $t('Marketplace Purchases') }}
                            el-button(
                                v-if="enabledExtensions.includes('shop:point-of-sale')"
                                :type="includeInternals == true ? 'primary' : 'info'"
                                size="mini"
                                :icon="includeInternals == true ? 'el-icon-fa-eye far' : 'el-icon-fa-eye-slash far'"
                                @click="toggleInternalsFilter"
                            )
                                | {{ $t('Internal Purchases') }}

                    transition(name="slide-decent-vertical")
                        .status-logs-container.z-depth-1(v-if="logs.length")
                            .spinner-container(v-if="loadingLogs")
                                .spinner
                            StatusLog(v-for="log in logs" :key="log.id" :log="log")
                                template(v-if="['success', 'error'].includes(log.status)" slot="actions")
                                    a.is-danger(href="#" @click.prevent="hideStatusLog(log)")
                                        i.el-icon-fa-times.fas

            template(v-slot:actions:th)
                .col-left(v-if="!showFilters")
                    //- https://codepen.io/danielhoppener/pen/xxKVbey
                    check-all(
                        :total="purchasesPaginated.pageInfo.total"
                        :show-dropdown="purchasesPaginated.pageInfo.lastPage > 1"
                        :checked="bulkSelection"
                        :is-indeterminate="selectionIndeterminate"
                        @check-all="checkAll"
                        @check-visible="checkVisible"
                    )
            template(v-slot:actions:filter)
                .col-left(v-if="showFilters" style="padding-left: 10px")
                    //- https://codepen.io/danielhoppener/pen/xxKVbey
                    check-all(
                        :total="purchasesPaginated.pageInfo.total"
                        :show-dropdown="purchasesPaginated.pageInfo.lastPage > 1"
                        :checked="bulkSelection"
                        :default-event="checkAllEvent"
                        :is-indeterminate="selectionIndeterminate"
                        @check-all="checkAll"
                        @check-visible="checkVisible"
                    )
            template(v-slot:actions="{ item }")
                .col-left
                    el-checkbox(
                        :key="item.id"
                        :value="isChecked(item.id)"
                        @change="checkItem(item)"
                    )

            //- template(v-if="showFilters" v-slot:info-before:filter)
            //-     .col-center
            //-         //- | {{ $t('Color indicators') }}
            //-         .condensed-indicators
            //-             span.indicator(
            //-                 v-for="indicator in options.indicator.items"
            //-                 :class="indicator.type"
            //-             )
            //- template(v-else v-slot:info-before:th)
            //-     .col-center
            //-         //- | {{ $t('Color indicators') }}
            //-         .condensed-indicators
            //-             span.indicator(
            //-                 v-for="indicator in options.indicator.items"
            //-                 :class="indicator.type"
            //-             )
            //- template(v-slot:info-before="{ item }")
            //-     nobr.col-center
            //-         .indicators
            //-             span.indicator(v-for="indicator in item.indicators.slice().sort((a, b) => a.id - b.id)" :class="indicator.type")

            template(v-slot:indicators:th)
                .col-center
                    //- | {{ $t('Color indicators') }}
                    .condensed-indicators
                        span.indicator(
                            v-for="indicator in options.indicator.items"
                            :class="indicator.type"
                        )

            template(v-slot:indicators:th)
                .col-center
                    //- | {{ $t('Color indicators') }}
                    .condensed-indicators
                        span.indicator(
                            v-for="indicator in options.indicator.items"
                            :class="indicator.type"
                        )

            template(v-slot:indicators:filter:option-template="{ item }")
                .flex.space-between
                    span {{ item.label }}
                    span.indicator(:class="item.key")

            template(v-slot:indicators="{ value }")
                nobr.col-center
                    .indicators
                        span.indicator(v-for="indicator in value.slice().sort((a, b) => a.id - b.id)" :class="indicator.type")

            template(v-slot:sub_total="{ item, value }")
                span {{ value | moneyFormat(getCurrency(item)) }}
            template(v-slot:invoice="{ item }")
                span(v-if="item.invoice_nr")
                    a(
                        href
                        :download="item.invoice_nr + '.pdf'"
                        target="_blank"
                        @click.prevent.stop="downloadInvoice(item)"
                    )
                        | {{ item.invoice_nr }}
            template(v-slot:tax_total="{ item, value }")
                span {{ value | moneyFormat(getCurrency(item)) }}
            template(v-slot:grand_total="{ item, value }")
                span {{ value | moneyFormat(getCurrency(item)) }}
            template(v-slot:purchaser_name="{ value }")
                span.gray(v-if="value === 'Guest'") {{ $t(value) }}
                span(v-else) {{ value }}
            template(v-slot:sold_by="{ value }")
                span {{ $t(value || 'Webshop') }}

    el-dialog.bulk-action-dialog(
        :title="bulk.modal.title"
        :visible.sync="bulk.modal.visibility"
        :close-on-click-modal="false"
        :width="bulk.modal.width"
        top="10vh"
        @closed="resetBulkModal"
    )
        .bulk-modal-body(v-if="bulk.modal.body" v-html="bulk.modal.body")
        .bulk-modal-body.indicators(v-if="bulk.action === 'change-indicators' && bulk.modal.data && bulk.modal.data.indicators")
            //- nobr.el-loading-parent--relative(style="display: inline-block; min-width: 90px")
            //-     template(v-if="options.indicator.loading")
            //-         .el-loading-mask
            //-         .spinner
            //-     a.indicator.is-outlined(
            //-         v-for="indicator in options.indicator.items"
            //-         :class="[ indicator.type, { active: indicators.find(el => el.id === indicator.id) } ]"
            //-         href="#"
            //-         @click.prevent.stop="toggleIndicator(indicator)"
            //-     )
            //-         i.el-icon-fa-check.fas(v-if="indicators.find(el => el.id === indicator.id)")
            //- label {{ $t('Select indicators') }}
            a.indicator.is-outlined(
                v-for="indicator in options.indicator.items"
                :class="[ indicator.type, { active: bulk.modal.data.indicators.find(el => el.id === indicator.id) } ]"
                href="#"
                @click.prevent.stop="toggleBulkModalIndicator(indicator)"
            )
                i.el-icon-fa-check.fas(v-if="bulk.modal.data.indicators.find(el => el.id === indicator.id)")

        template(slot="footer")
            .modal-footer
                .left
                    el-button(
                        v-for="button in bulk.modal.buttons.left" :key="button.label"
                        v-if="button.action"
                        :size="button.size || 'mini'"
                        :type="button.type"
                        :icon="button.icon"
                        @click="button.action"
                    ) {{ button.label }}
                .right
                    el-button(
                        v-for="button in bulk.modal.buttons.right" :key="button.label"
                        v-if="button.action"
                        :size="button.size || 'mini'"
                        :type="button.type"
                        :icon="button.icon"
                        @click="button.action"
                    ) {{ button.label }}
</template>

<i18n>
{
    "en": {
        "Found {total} purchases": "Found {total} purchases",
        "{total} selected": "{total} selected",
        "Do you really want to delete {total} purchases?": "Do you really want to delete {total} purchases?",
        "Do you really want to delete the selected purchase?": "Do you really want to delete the selected purchase?",
        "Delete {total} purchases": "Delete {total} purchases",
        "web-shop": "Webshop",
        "point-of-sale": "Point of Sale"
    },
    "de": {
        "Go": "Ausführen",
        "Selected purchases": "Markierte Bestellungen",
        "Select bulk action...": "Massenaktion auswählen...",
        "Found {total} purchases": "{total} Bestellungen gefunden",
        "{total} selected": "{total} ausgewählt",
        "Selection": "Auswahl",
        "Check all": "Alle auswählen",
        "Check visible": "Sichtbare auswählen",
        "An error occurred!": "Es ist ein Fehler aufgetreten!",

        "Change color indicators...": "Farbmarker ändern...",
        "Export sales" : "Umsätze exportieren",
        "Color indicators": "Farbmarker",
        "Select desired color indicators": "Gewünschte Farbmarker auswählen",
        "Add": "Hinzufügen",
        "Remove": "Entfernen",

        "New Purchase": "Neue Bestellung",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Purchase list could not be fetched.": "Bestellungsliste konnte nicht abgerufen werden.",
        "Point Of Sale Purchases": "Kassenverkäufe",
        "Web Shop Purchases": "Webshopverkäufe",
        "Marketplace Purchases": "Marktplatzbestellungen",
        "Internal Purchases": "Interne Aufträge",
        "web-shop": "Webshop",
        "point-of-sale": "Kasse",
        "Guest": "Gast"
    }
}
</i18n>

<script>
import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo'
import echo from '@/echo';

import { ensureFreshToken } from '@/helpers';
import StatusLogApi from '@/store/api/system/statusLog';
import PurchaseApi from '@/extensions/shop/store/api/purchase';

import router from '@/router'
import pinia from '@/pinia';
import { useAuthStore, useSetupStore, useRestrictedAreaMemberStore, useShopPurchaseStore, usePosSetupStore } from '@/stores';

import PaginatedItems from '@/components/PaginatedItems'
import StatusLog from '@/views/cms/Dashboard/widgets/logs/Partials/StatusLog';
import CheckAll from '@/components/CheckAll';
import Tabs from '@/extensions/shop/views/Partials/SalesTabs'
import Error from '@/components/Error'

export default {
    name: 'PurchasesComponent',
    props: {
        context: {
            type: String
        }
    },
    data() {
        return {
            error: false,
            marketplaceSoldByValues: [],
            // loading: true,
            disable: {
                showFilters: false,
            },
            bulk: {
                action: undefined,
                options: [
                    { value: 'change-indicators', label: this.$t('Change color indicators...') },
                    { value: 'export-sales', label: this.$t('Export sales') },
                ],
                modal: {
                    visibility: false,
                    width: '740px',

                    title: undefined,
                    body: undefined,
                    data: undefined,

                    buttons: {
                        left: [
                            {
                                size: 'mini',
                                icon: 'el-icon-fa-times fas',
                                label: this.$t('Dismiss'),
                                action: this.closeBulkModal,
                            }
                        ],
                        right: [],
                    }
                }
            },
            loadingLogs: false,
            logs: [],
        }
    },
    components: {
        PaginatedItems,
        StatusLog,
        CheckAll,
        Error,
        Tabs
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true)
            if (reload) this.initialize()
        },
    },
    computed: {
        bulkSelection() {
            let checked = 'none';
            const total = _.get(this.purchasesPaginated, 'pageInfo.total') || 0;

            const selection = this.purchasesPaginated.pageInfo.selection;

            if (selection.type === 'exclusive' && selection.identifiers.length < total) checked = 'all';
            else if (selection.type === 'inclusive' && selection.identifiers.length) {
                checked = 'visible';
                // const items = _.get(this.purchasesPaginated, 'items') || [];
                // const currentPageSelection = items.filter(el => selection.identifiers.includes(parseInt(el.id)));
                // if (currentPageSelection.length > 0) {
                //     checked = 'visible';
                // }
            }
            return checked;
        },
        selectionIndeterminate() {
            let indeterminate = false;

            const selection = this.purchasesPaginated.pageInfo.selection;

            if (selection.type === 'exclusive' && selection.identifiers.length) indeterminate = true;
            else if (selection.type === 'inclusive' && selection.identifiers.length) {
                const items = _.get(this.purchasesPaginated, 'items') || [];
                const currentPageSelection = items.filter(el => selection.identifiers.includes(parseInt(el.id)));
                indeterminate = currentPageSelection.length < items.length;
            }
            return indeterminate;
        },
        checkAllEvent() {
            let event = 'check-all';
            if (this.hasFilters) event = 'check-visible';
            return event;
        },

        showFilters() {
            return this.hasFilters || _.get(this.purchasesPaginated, 'showFilters') || false
        },
        hasFilters() {
            return !_.isEmpty(this.filters)
        },
        filters() {
            let filters = _.cloneDeep(this.purchasesPaginated.filters)
            delete filters.shop
            return filters
        },
        sort() {
            var variables = this.purchasesPaginated.variables;
            var defaultSort = this.purchasesPaginated.defaultSort || { field: 'id', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;

            return { field: order, direction };
        },
        activeShop() {
            return this.activeCms.shop
        },
        includeWebShopPurchases() {
            if (!this.enabledExtensions.includes('shop:point-of-sale') && !this.hasMarketplacePurchases) return true;

            const key = 'ex:shop_purchase:include_web_shop_purchases';
            const misc = _.get(this.user, 'settings.misc') || [];
            const setting = misc.find(item => item && item.key === key)

            const value = _.get(setting, 'value') || 'true'
            return value === 'true'
        },
        includeInternals() {
            if (!this.enabledExtensions.includes('shop:point-of-sale')) return false;

            const key = 'ex:shop_purchase:include_internals';
            const misc = _.get(this.user, 'settings.misc') || [];
            const setting = misc.find(item => item && item.key === key)

            const value = _.get(setting, 'value') || 'false'
            return value === 'true'
        },
        includePointOfSalePurchases() {
            if (!this.enabledExtensions.includes('shop:point-of-sale')) return false;

            const key = 'ex:shop_purchase:include_point_of_sale_purchases';
            const misc = _.get(this.user, 'settings.misc') || [];
            const setting = misc.find(item => item && item.key === key)

            const value = _.get(setting, 'value') || 'false'
            return value === 'true'
        },
        hasMarketplacePurchases() {
            return this.marketplaceSoldByValues.length > 0;
        },
        includeMarketplacePurchases() {
            if (!this.hasMarketplacePurchases) return true;

            const key = 'ex:shop_purchase:include_marketplace_purchases';
            const misc = _.get(this.user, 'settings.misc') || [];
            const setting = misc.find(item => item && item.key === key)

            const value = _.get(setting, 'value') || 'true'
            return value === 'true'
        },
        user() {
            return useAuthStore().user;
        },
        setupStore() {
            return useSetupStore();
        },
        memberStore() {
            return useRestrictedAreaMemberStore();
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        },
        member() {
            return this.memberStore.form;
        },
        shopPurchaseStore() {
            return useShopPurchaseStore(pinia);
        },
        posSetupStore() {
            return usePosSetupStore(pinia);
        },
        loading() {
            return this.shopPurchaseStore.loading;
        },
        purchasesPaginated() {
            return this.shopPurchaseStore.purchasesPaginated;
        },
        options() {
            return this.shopPurchaseStore.options;
        },
    },
    methods: {
        async downloadInvoice(item) {
            if (!item.latestInvoicePdf) return

            const name = `${item.invoice_nr}.pdf`

            const token = await ensureFreshToken()
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')

            const file = item.latestInvoicePdf
            let href = `${storageRoute}/files/${file.id}/${encodeURIComponent(file.name)}?download=${encodeURIComponent(name)}&token=${token}`

            let link = document.createElement('a');
            link.href = href;
            link.download = name;

            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        },
        fetchPillNumbers() {
            //reset reservations and shipping numbers for tab pills
            this.updateNumberOfPendingArticleReservations(0)
            this.updateNumberOfPendingArticleShippings(0)

            //request fresh numbers, if active-stock-id present
            const stockID = localStorage.getItem('active-stock-id');
            if (stockID) {
                this.fetchNumberOfPendingArticleReservations({ stockID })
                this.fetchNumberOfPendingArticleShippings({ stockID })
            }
        },
        isChecked(id) {
            let checked = false;

            const selection = this.purchasesPaginated.pageInfo.selection;
            switch (selection.type) {
                case 'inclusive':
                    checked = !!~selection.identifiers.map(el => parseInt(el)).indexOf(parseInt(id));
                    break;

                case 'exclusive':
                    checked = !~selection.identifiers.map(el => parseInt(el)).indexOf(parseInt(id));
                    break;
            }
            return checked;
        },
        initialize() {
            if (!this.enabledExtensions.includes('shop')) {
                this.updateLoading(true)
                return
            }

            this.initializeStatusLogSubscription();
            // this.fetchRelatedStatusLogs();
            this.fetchIndicatorOptions()
            this.updateLoading(true)
            this.refetch()
            this.fetchPillNumbers()
            this.fetchMarketplaceSoldByValues()
        },
        fetchMarketplaceSoldByValues() {
            const shopId = _.get(this.activeShop, 'id');
            if (!shopId) return;

            PurchaseApi.fetchSoldByValues(shopId)
                .then(values => {
                    this.marketplaceSoldByValues = values;
                    // Initial refetch used default (true). If user setting is off, refetch with correct value.
                    if (values.length && !this.includeMarketplacePurchases) {
                        this.refetch();
                    }
                })
                .catch(() => {
                    this.marketplaceSoldByValues = [];
                });
        },
        getCurrency(item) {
            return _.get(item, 'currency')
        },
        addPurchase() {
            if (this.context === 'member-purchases' && this.member) {
                // add member/customer related data
                // to state before redirecting

                const billingAddress = this.member.addresses.find(el => el.default_billing)
                    || this.member.addresses.find(el => el.type === 'billing')
                    || this.member.addresses.find(el => el.type === 'main')

                const shippingAddress = this.member.addresses.find(el => el.default_shipping)
                    || this.member.addresses.find(el => el.type === 'shipping')
                    || this.member.addresses.find(el => el.type === 'main')

                let customer
                if (this.member.customer) {
                    customer = {
                        id: this.member.customer.id,
                        nr: this.member.customer.nr,
                        customerGroup: _.cloneDeep(this.member.customer.customerGroup),
                        show_net_prices: this.member.customer.show_net_prices,
                        tax_free: this.member.customer.tax_free,
                        member: _.cloneDeep(this.member),
                    }

                    delete customer.member.customer
                    delete customer.member.media
                }

                this.setPurchaser({
                    id: this.$route.params.id,
                    gender: this.member.gender,
                    first_name: this.member.first_name,
                    last_name: this.member.last_name,
                    mobile: this.member.mobile,
                    phone: this.member.phone,
                    email: this.member.email,
                    billingAddress,
                    shippingAddress,
                    customer,
                })
            }

            const params = { id: 'new' };
            router.push({ name: 'purchase-form', params });
        },
        toggleWebShopPurchasesFilter() {
            const key = 'ex:shop_purchase:include_web_shop_purchases';
            const value = !this.includeWebShopPurchases

            this.updateLoading(true)
            this.saveMiscSettings({ key, value: value.toString() })
                .then(this.refetch)
            // this.$nextTick(this.refetch);
        },
        toggleInternalsFilter() {
            const key = 'ex:shop_purchase:include_internals';
            const value = !this.includeInternals

            this.updateLoading(true)
            this.saveMiscSettings({ key, value: value.toString() })
                .then(this.refetch)
            // this.$nextTick(this.refetch);
        },
        togglePointOfSalePurchasesFilter() {
            const key = 'ex:shop_purchase:include_point_of_sale_purchases';
            const value = !this.includePointOfSalePurchases

            this.updateLoading(true)
            this.saveMiscSettings({ key, value: value.toString() })
                .then(this.refetch)
            // this.$nextTick(this.refetch);
        },
        toggleMarketplacePurchasesFilter() {
            const key = 'ex:shop_purchase:include_marketplace_purchases';
            const value = !this.includeMarketplacePurchases

            this.updateLoading(true)
            this.saveMiscSettings({ key, value: value.toString() })
                .then(this.refetch)
        },
        handleClick(item) {
            const params = { id: item.id }
            router.push({ name: 'purchase-main', params })
        },
        handleSizeChange(itemsPerPage) {
            this.updateLoading(true)
            this.defineItemsPerPage(itemsPerPage)
            this.refetch()
        },
        handleCurrentChange(currentPage) {
            this.updateLoading(true)
            this.defineCurrentPage(currentPage)
            this.refetch()
        },
        handleColsShow(visibleColumns) {
            this.defineActiveColumns(visibleColumns)
            // apolloClient.cache.reset()
            apolloClient.clearStore()
        },
        handleFilterInputChange(key, value, debounce = true) {
            this.defineFilterValue({ key, value })

            if (debounce) {
                this.debouncedRefetch()
            } else {
                this.updateLoading(true)
                this.refetch()
            }
        },
        handleSortInputChange(key, value) {
            this.defineSort({ key, value });
            this.refetch();
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters

            let value = false
            if (!visible) value = true

            this.disable.showFilters = true
            this.defineFilterVisibility(value)
            this.saveFilterVisibility({ scope: 'ex', key: 'shop_purchase', value })
                .finally(() => this.disable.showFilters = false)
        },
        handleBulkAction(action = undefined) {
            if (!action) action = this.bulk.action;

            const completeRequest = ({ actions, data }) => {
                let promises = [];
                if (actions && actions.length) {
                    actions.forEach(async (action, i) => {
                        switch (action) {
                            case 'download-file':
                                promises.push(
                                    new Promise(async (resolve, reject) => {
                                        if (!data || !data.length || !data[i]) return reject('missing file in response');

                                        const file = data[i].split('/')
                                        const item = {
                                            id: file[0],
                                            name: file[1],
                                        }

                                        const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
                                        const table = 'files';
                                        const token = await ensureFreshToken()
                                        const link = `${storageRoute}/${table}/${item.id}/${encodeURIComponent(item.name)}?download&token=${token}`;

                                        let element = document.createElement('a');
                                        element.setAttribute('href', link);

                                        element.style.display = 'none';
                                        document.body.appendChild(element);

                                        element.click();
                                        document.body.removeChild(element);

                                        return resolve();
                                    })
                                )
                                break;


                            case 'refetch-list':
                                await apolloClient.clearStore();
                                promises.push(new Promise(async (resolve) => {
                                    await this.refetch();
                                    resolve();
                                }))
                                break;

                            case 'await-event-broadcast':
                                this.$notify.success({
                                    title: this.$t('Bulk action will be processed asynchronously'),
                                    message: this.$t('You will be notified once the action is completed'),
                                    iconClass: 'fas el-icon-fa-check',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });

                                // NOTE: new jobs are getting broadcasted
                                // there is no need to fetch them at this point
                                //
                                // await apolloClient.clearStore();
                                // promises.push(new Promise(async (resolve) => {
                                //     await this.fetchUnfinishedJobs();
                                //     resolve();
                                // }))
                                break;

                            default:
                                // eslint-disable-next-line
                                return reject('requested action is not supported');
                        }
                    })
                }

                return Promise.all(promises);
            }

            let total;
            switch (action) {
                case 'change-indicators':

                    // show dialog
                    this.bulk.modal.title = this.$t('Select desired color indicators');
                    this.bulk.modal.width = '400px';

                    this.$set(this.bulk.modal, 'data', {
                        indicators: []
                    });

                    this.bulk.modal.buttons.right = [
                        {
                            size: 'mini',
                            type: 'warning',
                            icon: 'el-icon-fa-ban fas',
                            label: this.$t('Remove'),
                            action: () => this.handleBulkAction('change-indicators:remove'),
                        },
                        {
                            size: 'mini',
                            type: 'success',
                            icon: 'el-icon-fa-check fas',
                            label: this.$t('Add'),
                            action: () => this.handleBulkAction('change-indicators:add'),
                        }
                    ];

                    this.$nextTick(() => {
                        this.bulk.modal.visibility = true;
                    });
                    break;

                case 'change-indicators:remove':
                case 'change-indicators:add':
                case 'export-sales':
                    this.bulk.modal.visibility = false;

                    let payload
                    if (['change-indicators:remove', 'change-indicators:add'].includes(action)) {
                        payload = this.bulk.modal.data.indicators
                    }

                    this.updateLoading(true);
                    this.processPaginationBulkAction({
                        action,
                        payload,
                        variables: {
                            includeWebShopPurchases: this.includeWebShopPurchases,
                            includeInternals: this.includeInternals,
                            includePointOfSalePurchases: this.includePointOfSalePurchases,
                            includeMarketplacePurchases: this.includeMarketplacePurchases,
                        }
                    })
                        .then(data => {
                            completeRequest(data)
                                .then(() => {
                                    // if (action === 'delete:soft') this.resetBulkSelection();

                                    if (data.actions.some(a => ['download-file', 'refetch-list'].includes(a))) {
                                        this.$notify.success({
                                            title: this.$t('Bulk action processed successfully!'),
                                            iconClass: 'fas el-icon-fa-check',
                                            position: 'bottom-left',
                                            customClass: 'dark',
                                            duration: 8000
                                        });
                                    }
                                })
                                .finally(() => {
                                    this.updateLoading(false)
                                })
                        })
                        .catch(err => {
                            // eslint-disable-next-line
                            console.error(err);
                            this.updateLoading(false);

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Bulk action could not be processed.'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        });
                    break;

                default:
                    this.updateLoading(false);
                    break;
            }
        },
        closeBulkModal() {
            this.bulk.modal.visibility = false;
        },
        resetBulkModal() {
            this.bulk.modal = {
                visibility: false,
                width: '740px',

                title: undefined,
                body: undefined,
                data: undefined,

                buttons: {
                    left: [
                        {
                            size: 'mini',
                            icon: 'el-icon-fa-times fas',
                            label: this.$t('Dismiss'),
                            action: this.closeBulkModal,
                        }
                    ],
                    right: [],
                }
            };
        },

        toggleBulkModalIndicator(indicator) {
            let indicators = _.cloneDeep(this.bulk.modal.data.indicators);
            const i = indicators.findIndex(el => el.id === indicator.id)
            if (i >= 0) {
                indicators.splice(i, 1);
            } else {
                indicators.push(indicator);
            }
            this.$set(this.bulk.modal.data, 'indicators', indicators);
        },


        refetch(showSpinner = true) {

            // always add the cms id to filters
            const shopID = this.activeShop.id
            const filter = {
                key: 'shop',
                match: shopID,
            }
            this.defineFilterValue({ key: 'shop', value: filter })

            //add member_id filter when context is member-purchases
            if (this.context === 'member-purchases') {
                const memberFilter = {
                    key: 'member_id',
                    match: this.$route.params.id,
                }
                this.defineFilterValue({ key: 'member_id', value: memberFilter })
            }

            if (showSpinner) this.updateLoading(true);

            return this.fetchPurchasesPaginated({
                includeWebShopPurchases: this.includeWebShopPurchases,
                includeInternals: this.includeInternals,
                includePointOfSalePurchases: this.includePointOfSalePurchases,
                includeMarketplacePurchases: this.includeMarketplacePurchases,
            })
                .then(() => this.updateLoading(false))
                .catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Purchase list could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.updateLoading(false);

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                })
        },

        debouncedRefetch: _.debounce(function () { // function scope is needed here
            this.updateLoading(true)
            this.refetch()
        }, useSetupStore(pinia).debounce || 300),

        initializeStatusLogSubscription() {
            if (!echo.client) {
                setTimeout(() => this.initializeStatusLogSubscription(), 10)
            } else {
                this.fetchRelatedStatusLogs();

                echo.client.private('cms.' + this.activeCms.id)
                    .listen('.status-log:created', async data => {
                        if (data.log && ['export-sales-to-csv'].includes(data.log.key)) {
                            // check if log is already in the list
                            const exists = this.logs.find(log => parseInt(log.id) === parseInt(data.log.id));

                            // if not, fetch it and add it to the list
                            if (!exists) {
                                const logs = await StatusLogApi.fetchList({
                                    id: data.log.id,
                                    cms: parseInt(this.activeCms.id),
                                    status: [
                                        'info',
                                        'success',
                                        'warning',
                                        'error',
                                    ],
                                    key: [
                                        'export-sales-to-csv',
                                    ],
                                    hide: false,
                                })
                                if (logs && logs.length) {
                                    this.logs = [...logs, ...this.logs]

                                    // order by created_at timestamp desc
                                    this.logs = _.orderBy(this.logs, 'created_at', 'desc')
                                    this.logs = _.uniqBy(this.logs, 'id');
                                }
                            }
                        }
                    })
                    .listen('.status-log:updated', async data => {
                        if (data.log && ['export-sales-to-csv'].includes(data.log.key)) {
                            // find the log in the list
                            // and update it
                            const index = this.logs.findIndex(log => parseInt(log.id) === parseInt(data.log.id));

                            if (index >= 0) {
                                // this.$set(this.logs, index, data.log);
                                if (data.log.hide) {
                                    this.logs = this.logs.filter(log => parseInt(log.id) !== parseInt(data.log.id));
                                } else {
                                    this.$set(this.logs[index], 'status', data.log.status);
                                    this.$set(this.logs[index], 'progress', data.log.progress);
                                    this.$set(this.logs[index], 'updated_at', data.log.updated_at);
                                    this.$set(this.logs[index], 'heading', data.log.heading);
                                    this.$set(this.logs[index], 'body', data.log.body);
                                    this.$set(this.logs[index], 'data', data.log.data);
                                    this.$set(this.logs[index], 'hide', data.log.hide);

                                    this.$set(this.logs[index], 'file', data.log.file);
                                }
                            } else {
                                // if not found, fetch it and add it to the list
                                const logs = await StatusLogApi.fetchList({
                                    id: data.log.id,
                                    cms: parseInt(this.activeCms.id),
                                    status: [
                                        'info',
                                        'success',
                                        'warning',
                                        'error',
                                    ],
                                    key: [
                                        'export-sales-to-csv',
                                    ],
                                    hide: false,
                                })
                                // if (logs && logs.length) {
                                //     // find the right place to insert the new log
                                //     const i = this.logs.findIndex(log => log.id > data.log.id)
                                //     if (i >= 0) this.logs.splice(i, 0, logs[0])
                                //     else this.logs.push(logs[0])
                                // }
                                if (logs && logs.length) {
                                    this.logs = [...logs, ...this.logs]

                                    // order by created_at timestamp desc
                                    this.logs = _.orderBy(this.logs, 'created_at', 'desc')
                                    this.logs = _.uniqBy(this.logs, 'id');
                                }
                            }
                        }
                    })
            }
        },
        fetchRelatedStatusLogs() {
            let variables = {
                cms: parseInt(this.activeCms.id),
                status: [
                    'info',
                    'success',
                    'warning',
                    'error',
                ],
                key: [
                    'export-sales-to-csv',
                ],
                hide: false,
                skip: 0,
                take: 10,
            };

            StatusLogApi.fetchList(variables)
                .then((logs) => this.logs = logs)
                .catch(err => console.error(err));
        },
        hideStatusLog(log) {
            this.loadingLogs = true;

            log = _.cloneDeep(log);
            if (log.file) delete log.file
            log.hide = true;

            StatusLogApi.update(log)
                .then(data => {
                    // remove from list
                    if (data.hide) {
                        this.logs = this.logs.filter(el => el.id !== log.id);
                    } else {
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Status log could not be hidden.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }
                })
                .catch(err => {
                    console.error(err)
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Status log could not be hidden.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    this.loadingLogs = false
                });
        },

        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        },
        saveMiscSettings(payload) {
            return this.setupStore.saveMiscSettings(payload);
        },
        fetchPurchasesPaginated(payload) {
            return this.shopPurchaseStore.fetchPurchasesPaginated(payload);
        },
        processPaginationBulkAction(payload) {
            return this.shopPurchaseStore.processPaginationBulkAction(payload);
        },
        fetchIndicatorOptions() {
            return this.shopPurchaseStore.fetchIndicatorOptions();
        },
        updateLoading(value) {
            this.shopPurchaseStore.updateLoading(value);
        },
        defineItemsPerPage(value) {
            this.shopPurchaseStore.defineItemsPerPage(value);
        },
        defineCurrentPage(value) {
            this.shopPurchaseStore.defineCurrentPage(value);
        },
        defineActiveColumns(value) {
            this.shopPurchaseStore.defineActiveColumns(value);
        },
        defineFilterValue(payload) {
            this.shopPurchaseStore.defineFilterValue(payload);
        },
        definePathValue(payload) {
            this.shopPurchaseStore.definePathValue(payload);
        },
        defineFilterVisibility(value) {
            this.shopPurchaseStore.defineFilterVisibility(value);
        },
        defineSort(payload) {
            this.shopPurchaseStore.defineSorting(payload);
        },
        checkAll(payload) {
            this.shopPurchaseStore.paginationBulkSelectionCheckAll(payload);
        },
        checkVisible(payload) {
            this.shopPurchaseStore.paginationBulkSelectionCheckVisible(payload);
        },
        checkItem(item) {
            this.shopPurchaseStore.paginationBulkSelectionCheckItem(item);
        },
        resetBulkSelection() {
            this.shopPurchaseStore.paginationBulkSelectionReset();
        },
        setPurchaser(purchaser) {
            this.shopPurchaseStore.setFormPurchaser(purchaser);
        },
        fetchNumberOfPendingArticleReservations(payload) {
            return this.posSetupStore.fetchNumberOfPendingArticleReservations(payload);
        },
        fetchNumberOfPendingArticleShippings(payload) {
            return this.posSetupStore.fetchNumberOfPendingArticleShippings(payload);
        },
        updateNumberOfPendingArticleReservations(value) {
            this.posSetupStore.updateNumberOfPendingArticleReservations(value);
        },
        updateNumberOfPendingArticleShippings(value) {
            this.posSetupStore.updateNumberOfPendingArticleShippings(value);
        },
    },
    mounted() {
        this.initialize()
    },
    beforeDestroy() {
        if (echo.client) {
            echo.client.private(`cms.${this.activeCms.id}`)
                .stopListening('.status-log:created')
                .stopListening('.status-log:updated')
        }
    },
}
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variables'

.purchase-list:deep()
    .info-before
        white-space: nowrap
        width: 10px
    .column
        &.payed_at,
        &.updated_at,
        &.created_at,
        &.purchaser_name
            white-space: nowrap
.gray
    color: lighten($color-grey-text, 10%)

.table-top .row + .row
    margin-top: 0.5rem

.condensed-indicators
    z-index: 0
    .indicator
        width: 14px
        height: 14px
        margin-bottom: -2px
        border: 2px solid $color-selection
        position: relative
        & + .indicator
            margin-left: -8px
        @for $i from 1 through 10
            &:nth-child(#{$i})
                z-index: #{10 - $i}

.bulk-modal-body.indicators
    display: flex
    align-items: center
    justify-content: center
    .indicator
        width: 30px
        height: 30px
        border-width: 2px
        font-size: 2rem
        position: relative
        i.fas
            position: absolute
            left: calc(50% - 0.45em)
            top: calc(50% - 0.45em)
            color: white
            font-size: 0.6em

a.is-danger
    color: $--color-danger
    &:hover
        color: inherit


// #customBtn.el-button--primary
//         background: #6E26FF
// #customBtn.el-button--primary:focus
//     background: #6E26FF
// #customBtn.el-button--primary:hover
//     background: #909399
// #customBtn.el-button--info:hover
//     background: #6E26FF
// #customBtn.el-button--info:focus
//     background: #909399
</style>

<style lang="sass">
    .error
        padding: 20px
</style>
